export default __webpack_public_path__ + "static/media/BMMF01.e7deb38f.jpg";